(function () {
    const formPriceSignatures = new WeakMap();

    function formatPrice(value) {
        const n = parseInt(value, 10);
        if (isNaN(n)) return '';
        return '€ ' + n.toLocaleString('nl-NL');
    }

    // Count how many digit characters appear before the caret position.
    function countDigits(str, upto) {
        let count = 0;
        for (let i = 0; i < upto && i < str.length; i++) {
            if (str[i] >= '0' && str[i] <= '9') count++;
        }
        return count;
    }

    // Find the caret position that sits right after the Nth digit.
    function caretAfterDigit(str, digitCount) {
        if (digitCount <= 0) {
            for (let i = 0; i < str.length; i++) {
                if (str[i] >= '0' && str[i] <= '9') return i;
            }
            return str.length;
        }
        let seen = 0;
        for (let i = 0; i < str.length; i++) {
            if (str[i] >= '0' && str[i] <= '9') {
                seen++;
                if (seen === digitCount) return i + 1;
            }
        }
        return str.length;
    }

    // Build a signature of all price values in a form, to detect real changes.
    function priceSignature(form) {
        return Array.from(form.querySelectorAll('.price-combobox-wrapper input[type="hidden"]'))
            .map(function (h) { return h.name + '=' + h.value; })
            .join('&');
    }

    function parseOptionsJson(json) {
        try {
            return JSON.parse(json);
        } catch (e) {
            return {};
        }
    }

    function buildOptionsList(optionsObj, isTill) {
        const items = [];
        if (isTill) {
            items.push({ key: '', label: 'Geen max.' });
        }
        Object.keys(optionsObj).forEach(function (key) {
            if (key === '') return; // skip PHP placeholder entry
            items.push({ key: key, label: optionsObj[key] });
        });
        return items;
    }

    function renderDropdown(items, dropdown, query) {
        dropdown.innerHTML = '';
        const q = (query || '').replace(/[^0-9]/g, '');

        items.forEach(function (item) {
            if (q && item.key !== '') {
                const keyMatch = item.key.indexOf(q) !== -1;
                const labelMatch = item.label.replace(/[^0-9]/g, '').indexOf(q) !== -1;

                if (!keyMatch && !labelMatch) return;
            }

            const li = document.createElement('li');
            li.className = 'price-combobox-option';
            li.textContent = item.label;
            li.dataset.key = item.key;
            dropdown.appendChild(li);
        });

        dropdown.classList.add('price-combobox-dropdown--open');
    }

    function closeDropdown(dropdown) {
        dropdown.classList.remove('price-combobox-dropdown--open');
        dropdown.innerHTML = '';
    }

    function validatePrices(form) {
        const fromInput = form.querySelector('input[type="hidden"][name$="_from"]');
        const tillInput = form.querySelector('input[type="hidden"][name$="_till"]');

        if (!fromInput || !tillInput) return true;

        const from = parseInt(fromInput.value, 10);
        const till = parseInt(tillInput.value, 10);

        if (!isNaN(from) && !isNaN(till) && from > 0 && till > 0 && from > till) {
            form.querySelectorAll('.price-combobox-wrapper').forEach(function (w) {
                w.classList.add('price-error');
            });

            return false;
        }

        form.querySelectorAll('.price-combobox-wrapper').forEach(function (w) {
            w.classList.remove('price-error');
        });

        return true;
    }

    // Auto-apply only on desktop; mirrors isDesktop() in objects/index.twig.
    // On mobile the "Bekijk woningaanbod" apply button submits the form, so
    // typing/selecting/blurring a price must not trigger a reload.
    function isDesktop() {
        return window.matchMedia('(min-width: 1280px)').matches;
    }

    function submitActiveForm(input) {
        if (!isDesktop()) return;

        const form = input.closest('form');

        if (!form || !validatePrices(form)) return;

        // Skip a reload to an identical URL when nothing actually changed.
        const sig = priceSignature(form);
        if (formPriceSignatures.get(form) === sig) return;
        formPriceSignatures.set(form, sig);

        form.submit();
    }

    function initCombobox(wrapper) {
        const input = wrapper.querySelector('.price-combobox-input');
        const hidden = wrapper.querySelector('input[type="hidden"]');
        const dropdown = wrapper.querySelector('.price-combobox-dropdown');

        if (!input || !hidden || !dropdown) return;

        const optionsObj = parseOptionsJson(input.dataset.options || '{}');
        const isTill = input.dataset.name && input.dataset.name.indexOf('_till') !== -1; // used by buildOptionsList
        const allItems = buildOptionsList(optionsObj, isTill);

        input.addEventListener('focus', function () {
            renderDropdown(allItems, dropdown, '');
        });

        input.addEventListener('input', function () {
            const prev = input.value;
            const caret = input.selectionStart;
            const digitsBefore = countDigits(prev, caret);
            const raw = prev.replace(/[^0-9]/g, '');

            // Keep the submitted value in sync live (no blur race).
            hidden.value = raw;

            // Live-format the visible value and restore the caret.
            const formatted = raw ? formatPrice(raw) : '';
            input.value = formatted;
            if (formatted && input === document.activeElement) {
                const pos = caretAfterDigit(formatted, digitsBefore);
                input.setSelectionRange(pos, pos);
            }

            renderDropdown(allItems, dropdown, raw);
            // No auto-submit while typing: the form only submits on Enter or
            // when the user leaves the field (blur).
        });

        dropdown.addEventListener('mousedown', function (e) {
            const li = e.target.closest('.price-combobox-option');

            if (!li) return;

            e.preventDefault();

            const key = li.dataset.key;

            hidden.value = key;
            input.value = key === '' ? '' : formatPrice(key);

            closeDropdown(dropdown);

            // Picking an option is an explicit choice: submit right away.
            submitActiveForm(input);
        });

        input.addEventListener('blur', function (e) {
            // Re-sync/format the value (e.g. after a paste); the hidden value
            // is already kept in sync on input.
            const raw = input.value.replace(/[^0-9]/g, '');
            hidden.value = raw;
            input.value = raw ? formatPrice(raw) : '';

            // Submit when the user leaves the field, except when focus moves
            // to the sibling price field in the same form (e.g. tabbing from
            // "vanaf" to "tot") — that must not trigger a reload mid-editing.
            const next = e.relatedTarget;
            const form = input.closest('form');
            const movingToSiblingPrice = next
                && next.classList
                && next.classList.contains('price-combobox-input')
                && next.closest('form') === form;

            if (!movingToSiblingPrice) {
                submitActiveForm(input);
            }

            setTimeout(function () {
                closeDropdown(dropdown);
            }, 200);
        });

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();

                const highlighted = dropdown.querySelector('.price-combobox-option--highlighted');

                if (highlighted) {
                    const key = highlighted.dataset.key;

                    hidden.value = key;
                    input.value = key === '' ? '' : formatPrice(key);

                    closeDropdown(dropdown);
                } else {
                    const raw = input.value.replace(/[^0-9]/g, '');

                    hidden.value = raw || '';
                    input.value = raw ? formatPrice(raw) : '';
                }

                submitActiveForm(input);
            }

            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();

                const options = Array.from(dropdown.querySelectorAll('.price-combobox-option'));

                if (!options.length) return;

                let idx = options.findIndex(function (o) {
                    return o.classList.contains('price-combobox-option--highlighted');
                });

                options.forEach(function (o) {
                    o.classList.remove('price-combobox-option--highlighted');
                });

                if (e.key === 'ArrowDown') {
                    idx = Math.min(idx + 1, options.length - 1);
                } else {
                    idx = Math.max(idx - 1, 0);
                }

                options[idx].classList.add('price-combobox-option--highlighted');
                options[idx].scrollIntoView({ block: 'nearest' });
            }

            if (e.key === 'Escape') {
                closeDropdown(dropdown);
            }
        });
    }

    function init() {
        document.querySelectorAll('.price-combobox-wrapper').forEach(initCombobox);

        // Record the applied price state per form so an unchanged
        // value never triggers a reload to the same URL.
        document.querySelectorAll('form').forEach(function (form) {
            if (form.querySelector('.price-combobox-wrapper')) {
                formPriceSignatures.set(form, priceSignature(form));
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();